module.exports = __webpack_public_path__ + "static/media/p11.22123e35.jpeg";